



































import { Component, Vue, Watch } from 'vue-property-decorator';
import { Mutations, Actions } from '@/ts/store/Constants';

@Component
export default class SetPin extends Vue {
    public input: string[] = [];
    public testPin = '1234';
    public firstPin = '';
    public repeatPin = '';
    public inputFailure: boolean = false;
    public stage = 1;

    constructor() {
        super();
    }

    get message(): string {
        if (this.stage === 1) {
            return (this.inputFailure === false)
                ? this.$t('user.please-set-a-pin', 'Please set a PIN code.')
                : this.$t('user.pin-does-not-match', 'Codes do not match. Try again.');
        }

        if (this.stage === 2) {
            return this.$t('user.please-repeat-pin', 'Please repeat your PIN.');
        }
    }

    get inputPin(): string {
        return this.input.join('');
    }

    get inputLength(): number {
        return this.input.length;
    }

    get email(): string {
        return this.$store.state.User.email;
    }

    @Watch('inputLength')
    public checkPin() {
        if (this.input.length === 4) {
            if (this.stage === 1) {
                this.firstPin = this.inputPin;
                this.input = [];
                this.stage = 2;
                return;
            }

            if (this.stage === 2) {
                this.repeatPin = this.inputPin;

                if (this.repeatPin === this.firstPin) {
                    this.$store.dispatch(Actions.SET_PIN, this.firstPin);
                    this.$store.commit(Mutations.SHOW_SET_PIN, false);
                    return;
                } else {
                    this.input = [];
                    this.inputFailure = true;
                    this.stage = 1;
                    return;
                }
            }
        }
    }

    public buttonAction(action: string) {
        if (action === 'X') {
            this.input = [];
            return;
        }

        if (action === 'OK' && this.input.length < 4) {
            // this.makeNoise();
            return;
        }

        if (this.input.length < 4) {
            this.input.push(action);
        }
    }

    public numberClasses(action: string) {
        return {
            'hococo-pin-keypad__number': true,
            'hococo-pin-keypad-number--zero': (action === '0'),
            'hococo-pin-keypad-number--submit': (action === 'OK'),
        };
    }

    public digitClasses(digit: number) {
        return {
            'hococo-pin-indicator__digit': true,
            'hococo-pin-indicator-digit--current': (digit === this.input.length + 1),
            'hococo-pin-indicator-digit--done': (this.input.length >= digit),
        };
    }

    public fieldClasses(action: string) {
        return {
            'hococo-pin-keypad-number__field': true,
            'hococo-pin-keypad-number-field--delete': (action === 'X'),
            'hococo-pin-keypad-number-field--submit': (action === 'OK'),
        };
    }
}
